// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@awc/Overrides/Widgets/Common/HeaderSignIn";
import { DivWrapper } from "@awc/XDL/constants";
import Close from "@awc/XDL/Icons/Close";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { DrawerPresentationProps } from "@insite/mobius/Drawer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

headerSignInStyles.titleTypography = {
    css: css`
        margin-left: 8px;
        ${xScreen("lte", "sm")} {
            margin-left: 0;
        }
    `,
    size: fontConfig.fontSize.small,
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    color: "primary.main",
    ellipsis: true,
    transform: "none",
};
headerSignInStyles.titleIcon = {
    size: 14,
    color: "primary.main",
    css: css`
        &,
        svg {
            width: 12px;
        }
        ${xScreen("lte", "sm")} {
            &,
            svg {
                width: 17px;
                height: 20px;
            }
        }
    `,
};
headerSignInStyles.titleClickable = {
    css: css`
        padding-left: 12px;
        max-width: 160px;
        padding-right: 12px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            max-width: 120px;
        }
        ${xScreen("lte", "sm")} {
            margin: 0;
            border: none;
        }
    `,
};

headerSignInStyles.signInClickable = {
    css: css`
        display: none;
        margin-left: 12px;
        max-width: 160px;
        padding-right: 12px;
        ${xScreen("lte", "sm")} {
            display: block;
            max-width: 56px;
        }
    `,
};
headerSignInStyles.signOutWrapper = {
    css: css`
        padding: 0;
        display: flex;
        align-items: center;
        min-height: 36px;
        ${xScreen("lte", "md")} {
            flex-wrap: wrap;
        }
        ${xScreen("lte", "sm")} {
            border: 1px solid ${color("common.ui3")};
            background: ${color("common.ui2")};
            border-top: 0;
            border-right: 0;
        }
    `,
};
headerSignInStyles.langugaeAndCurrencyWrapper = {
    css: css`
        display: flex;
        & > ${DivWrapper}:empty {
            display: none;
        }
    `,
};
headerSignInStyles.signOutClickable = {
    css: css`
        padding: 0 12px;
        border-right: 1px solid ${color("common.ui3")};
        & > ${TypographyStyle} {
            margin: 0;
        }

        ${xScreen("lte", "sm")} {
            border: 0;
            background: ${color("common.ui2")};
            width: 41px;
        }
    `,
};
headerSignInStyles.userInfoWrapper = {
    css: css`
        display: flex;
        min-height: 36px;
        .header-brandlogo {
            &:hover,
            &:focus {
                background-color: ${color("common.ui15")};
            }
        }
    `,
};

const baseDrawerStyles: DrawerPresentationProps = {
    closeButtonProps: {
        shape: "rectangle",
        buttonType: "solid",
        color: "common.ui1",
        size: 36,
        css: css`
            padding: 0 24px;
            &,
            &:hover,
            &:focus {
                background: transparent;
                border: none;
            }
        `,
    },
    closeButtonIconProps: {
        src: Close,
        size: 16,
    },
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            margin: 0 45px 12px;
            overflow-y: inherit;
        `,
        drawerBody: css`
            height: auto;
            max-height: 600px;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
        drawerTitle: css`
            background: ${color("primary.main")};
            color: ${color("common.ui1")};
            margin-bottom: 16px;
        `,
        headlineTypography: css`
            margin: 7px 0 7px 60px;
            ${xScreen("lte", "sm")} {
                margin-left: 45px;
            }
        `,
    },
    headlineTypographyProps: {
        color: "common.ui1",
    },
};

headerSignInStyles.drawer = baseDrawerStyles;
headerSignInStyles.drawerInShell = {
    ...baseDrawerStyles,
    cssOverrides: {
        ...baseDrawerStyles.cssOverrides,
        drawerBody: css`
            height: auto;
            overflow-x: inherit;
            overflow-y: inherit;
        `,
    },
};
headerSignInStyles.drawerInPunchOut = {
    ...baseDrawerStyles,
    cssOverrides: {
        ...baseDrawerStyles.cssOverrides,
        drawerBody: css`
            overflow-x: inherit;
            overflow-y: show;
        `,
    },
};
